import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-uploadfile-config',
  templateUrl: './d-uploadfile-config.component.html',
  styles: []
})
export class DUploadfileConfigComponent extends DynamicComponentBase {
  static KEY = 'd-uploadfile-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
